'use strict';



(function($) {
    $(document).on('ready', function() {

        // @codekit-prepend 'core/functions.js'
        // @codekit-prepend 'plugins/browser_detection.js'
        // @codekit-prepend 'plugins/effect_on_scroll.js'
        // @codekit-prepend 'plugins/image_to_background.js'
        // @codekit-prepend 'plugins/move_element_to_another'
        // @codekit-prepend 'plugins/qty_resize.js'
        // @codekit-prepend 'plugins/slider.js'
        // @codekit-prepend 'plugins/smooth_scrolling.js'
        // @codekit-prepend 'plugins/tables.js'
        // @codekit-prepend 'plugins/tabtrap.js'


        //
        //
        //
        ///////////////////////////////////////////////////////////////////////////
        //														                  
        //													 		              
        //				     Start of Custom JS                  		  
        //						 No custom JS Above this box   		                  
        //												
        //					      
        ///////////////////////////////////////////////////////////////////////////




        //slick
        $('.ncr-slider').initiateSlick({
            slider_speed: 9000,
            nextArrow: '<div class="right"><span class="fa fa-caret-right" aria-label="next" role="img"></span></div>',
            prevArrow: '<div class="left"><span class="fa fa-caret-left" aria-label="previous" role="img"></span></div>',
            dots: 'false'
        });





        //resizer and reorganizer Quick links
        $('.band-blog-post-list .feature-wrap').qtyResize({
            width: 'width-medium'
        });
        //resizer and reorganizer Quick links
        $('.feature-wrap[class*="feature-wrap-quicklinks"]').qtyResize({
            width: 'width-medium'
        });
        //resizer and reorganizer Rates
        $('.feature-wrap[class*="feature-wrap-rates"]').qtyResize({
            width: 'width-medium'
        });
        //resizer and reorganizer Testimonals
        $('.feature-wrap[class*="feature-wrap-testimonials"]').qtyResize({
            width: 'width-narrow'
        });
        // //resizer and reorganizer Promos
        $('.feature-wrap[class*="feature-wrap-promos"]').qtyResize({
            width: 'width-medium'
        });



        //scrolls to top of menu if menu is opened and has been previously scrolled
        $('.band-menu-panel').on('ncr-panel-opened', function() {
            $('.band-menu-panel').scrollTop(0);
        })



        //cover image
        $('.cover-image-hero').moveImageToBg({
            bgPosition: 'center center'
        });
        setTimeout(function() {
            $('.cover-image-hero').moveImageToBg({
                bgPosition: 'center center'
            });
        }, 100);

        $('.cover-image').moveImageToBg({
            bgPosition: 'center center'
        });



        //js required testimonials-v005
        $('.feature-wrap-testimonials-1').randomize().slick({
            centerMode: true,
            slidesToShow: 1,
            speed: 1000,
            autoplaySpeed: 10000,
            autoplay: true,
            slide: ".feature",
            arrows: true,
            fade: true,
            nextArrow: '<span class="icon-utility-caret-right" aria-label="next" role="img"></span>',
            prevArrow: '<span class="icon-utility-caret-left" aria-label="previus" role="img"></span>'
        });




        //header
        if ($('header').length > 0) {
            $('.band-menu-panel').addClass('panel-overlay');
            $('.band-login-panel').addClass('panel-overlay');
            $('header').find('.feature-content[ncr-panel]').addClass('panel-off-1200 panel-accordion');
            $('header').find('.feature-content[ncr-panel] .menu-list [ncr-panel]').addClass('panel-off-1200 panel-accordion');
            $('header').find('.feature.search [ncr-panel]').addClass('panel-off-1200');
        }


        //panels
        $("body").tabTrapping();


        //utility 1 to header
        $('header .band-utility-1 .feature-wrap').moveElementAround({
                insideBefore: "header .band-menu-panel .feature-wrap-menu",
                //insideAfter: "header .band-menu-panel .feature-wrap",
                returnAbove: 915
            })
            //utility 2 to header
        $('header .band-utility-2 .feature-wrap').moveElementAround({
                insideBefore: "header .band-menu-panel .feature-wrap-menu",
                //insideAfter: "header .band-menu-panel .feature-wrap",
                returnAbove: 9999
            })
            //utility 3 to header
        $('header .band-utility-3 .feature-wrap').moveElementAround({
                insideBefore: "header .band-menu-panel .feature-wrap-menu",
                //insideAfter: "header .band-menu-panel .feature-wrap",
                returnAbove: 9999
            })
            //utility 4 to header
        $('header .band-utility-4 .feature-wrap').moveElementAround({
            insideBefore: "header .band-menu-panel .feature-wrap-menu",
            //insideAfter: "header .band-menu-panel .feature-wrap",
            returnAbove: 9999
        })







        // $('.clickable-div').each(function(){
        //     var link = $(this).find('.feature-cta > a').attr("href");
        //     console.log(link)
        //     $(this).wrapInner('<a href=""></a>')
        // })



        // $('.blog-search .feature').on('mouseover', function(){

        //   var bg = $('.blog-search .bg-animate');
        //   $(bg).appendTo(this).show();

        // })
        // $('.blog-search .feature').on('mouseleave', function(){
        //   var active = $('.blog-search .active');
        //   var bg = $('.blog-search .bg-animate');
        //   $(bg).appendTo(active).show();
        // })

        //add content-hero to main
        $('.col-main div[class*="breadcrumbs"]').prependTo('main');
        //add content-hero to main
        $('.col-main div[class*="content-hero"]').prependTo('main');







        ///////////////////////////////////////////////////////////////////////////
        //														                  
        //													 		              
        //				            End of Custom JS                  		  
        //						 No JS below this box   		                  
        //												
        //					      
        ///////////////////////////////////////////////////////////////////////////
        //
        //
        //
    });
})(jQuery); // or even jQuery.noConflict()